<template>
  <component
    :is="eventComponent"
    :event="event"
    :context="context"
    v-bind="$attrs"
  ></component>
</template>

<script>
import AppointmentEvent from "./AppointmentEvent.vue";
import CalendarEvent from "./CalendarEvent.vue";
import PreworkEvent from "./PreworkEvent.vue";
import SimpleEvent from "./SimpleEvent.vue";
import TravelEvent from "./TravelEvent.vue";

export default {
  props: {
    context: {
      type: Object,
      default: null
    }
  },
  computed: {
    event() {
      return this.context.event;
    },
    eventComponent() {
      const details = this.event.extendedProps;
      if (details.travel) {
        return TravelEvent;
      }
      if (details.pre_work) {
        return PreworkEvent;
      }
      if (details.calendar_event) {
        return CalendarEvent;
      }
      if (details.schedule) {
        return SimpleEvent;
      }
      return AppointmentEvent;
    }
  }
};
</script>

<style lang="scss" scoped></style>
